import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  darkMode: true,
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleDarkMode(state) {
      state.darkMode = true
    },
    setDarkMode(state, action) {
      state.darkMode = true
    },
  },
})

export const {toggleDarkMode, setDarkMode} = themeSlice.actions

export const selectDarkMode = state => state.theme.darkMode

export default themeSlice.reducer
